<template>
  <base-home-page>
    <template v-if="!isLoading">
      <div>
        <form>
          <div class="form-group">
            <label for="password">New Password:</label>
            <input v-model="password" id="password" type="password" class="form-control" />
            <span v-show="errors['password']" class="help-block">{{ errors['password'] }}</span>
          </div>
          <div class="form-group">
            <label for="password-confirmation">New Password Confirmation:</label>
            <input
              v-model="passwordConfirmation"
              id="password-confirmation"
              type="password"
              class="form-control"
            />
            <span v-show="errors['passwordConfirmation']" class="help-block">{{
              errors['passwordConfirmation']
            }}</span>
          </div>
          <button @click.prevent="submitForm" class="btn btn-block btn-success">
            Reset Password
          </button>
        </form>
      </div>
    </template>
    <template v-else>
      <capsim-loader
        :text-style="{ fontWeight: 400 }"
        :container-style="loaderStyle"
        :loader-text="'Resetting password...'"
      >
      </capsim-loader>
    </template>
    <p>{{ serverError }}</p>
  </base-home-page>
</template>
<script>
  import CapsimLoader from '@shared/CapsimLoader.vue';
  import BaseHomePage from '@shared/BaseHomePage.vue';
  export default {
    name: 'ResetPassword',

    components: {
      CapsimLoader,
      BaseHomePage,
    },

    data() {
      const token = this.$route.query.token;
      return {
        password: '',
        passwordConfirmation: '',
        errors: {},
        isLoading: false,
        serverError: '',
        token,
        loaderStyle: {
          position: 'relative',
          height: '200px',
          fontSize: '14px',
        },
      };
    },

    methods: {
      validateForm() {
        let errors = {};
        if (this.password < 6)
          errors['password'] = 'Password should have a minimum of 6 characters';
        if (this.passwordConfirmation !== this.password)
          errors['passwordConfirmation'] = 'Password confirmation should match the password';

        return errors;
      },

      submitForm() {
        this.serverError = '';
        this.errors = this.validateForm();

        if (Object.keys(this.errors).length) return;

        this.isLoading = true;

        $.ajax({
          url: '/capsiminbox/authoring-platform/reset-password',
          method: 'POST',
          data: JSON.stringify({
            token: this.token,
            password: this.password,
          }),
          contentType: 'application/json',
          dataType: 'json',
        })
          .done((response) => {
            if (response.success) return (window.location = '/capsiminbox/authoring-platform');
            else
              this.errors = response.messages.reduce((acc, { key, message }) => {
                acc[key] = message;
                return acc;
              }, {});

            this.isLoading = false;
          })
          .catch(
            (err) => (this.serverError = 'There was a problem while processing your request.')
          );
      },
    },
  };
</script>
